// Sections whose "View More" names come from the patient's chart (exercises,
// CPT codes, goal text, activity text) instead of the EMR's layout. Their
// names are never saved to the template. Goal lists are arrays (skipped below).
const PATIENT_DATA_SECTION =
  /flowsheet|treatments|charge|billing|activity|procedure|goal \/ objective data/i;

// Keeps one section's saved names (and the config item) small.
const MAX_NAMES_PER_SECTION = 150;

/**
 * After a scan: the subsection name lists to save, keyed by section. Only
 * sections that gained a name are returned, each with its full saved list.
 */
export function subsectionNamesToSave(emrQuestions, savedNames) {
  const updates = {};
  emrQuestions.forEach((element) => {
    const key = element.Key?.trim();
    if (
      !key ||
      !element.subSections ||
      Array.isArray(element.Structure) ||
      PATIENT_DATA_SECTION.test(key)
    ) {
      return;
    }
    const saved = Array.isArray(savedNames[key]) ? savedNames[key] : [];
    const scanned = Object.keys(element.subSections).filter(
      (name) => name.trim() && !/^\d+$/.test(name.trim()),
    );
    const added = scanned.filter((name) => !saved.includes(name));
    if (added.length === 0) return;
    // Past the cap the names are per-note data, not layout: start over from
    // this scan. Edited subsections live in the instruction, so none are lost.
    updates[key] =
      saved.length + added.length > MAX_NAMES_PER_SECTION
        ? scanned.slice(0, MAX_NAMES_PER_SECTION)
        : [...saved, ...added];
  });
  return updates;
}

/**
 * Note Settings / library view: each section's saved SubSections, then an
 * empty entry for every saved name nobody has edited yet.
 */
export function withSavedSubsectionNames(subsections, savedNames) {
  const merged = { ...subsections };
  Object.entries(savedNames || {}).forEach(([key, names]) => {
    if (!Array.isArray(names) || names.length === 0) return;
    const section = { ...(subsections[key] || {}) };
    names.forEach((name) => {
      if (!(name in section)) section[name] = {};
    });
    merged[key] = section;
  });
  return merged;
}
